import CONFIG, { countries, defaultCountry, siteCommunityUrl, isBeYeuTemplate, siteNewsUrl } from '../config'
import crypto from 'crypto'

export const myIsSet = (obj, key) => {
    if(typeof obj == "undefined") {
        return false;
    }

    const keys = key.split('.');
    if(keys.length == 0) {
        return false;
    }

    for(const i in keys) {
        if(obj != null && obj.hasOwnProperty(keys[i])) {
            obj = obj[keys[i]];
        }
        else {
            return false;
        }
    }

    return true;
}

export const cloneEvent = (e) => {
    if (e===undefined || e===null) return undefined;
    function ClonedEvent() {};
    const clone=new ClonedEvent();
    for (const p in e) {
        const d=Object.getOwnPropertyDescriptor(e, p);
        if (d && (d.get || d.set)) Object.defineProperty(clone, p, d); else clone[p] = e[p];
    }
    Object.setPrototypeOf(clone, e);
    return clone;
}

export const isObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export const mobileCheck = () => {
    let check = false;
      if(typeof window != "undefined") {
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      }

   return check;
}

export const offset = (el) =>  {
    if(typeof window != "undefined" && el != null) {
        const rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        return {
            top: rect.top + scrollTop,
            left: rect.left + scrollLeft,
            viewPortTop: rect.top
        }
    }
    else {
        return false
    }
}

export const gtmSend = (event, category, action, label, value = 1, params={}) => {
    if(typeof window !== "undefined") {
        event = event === 'dynamic' ? 'dynamic event' : event

        if(process.env.REACT_APP_ENV !== 'production') {
            console.log(event, '|', category, '|', action, '|', label, '|', value, '|', params);    
        }
        
        if(process.env.REACT_APP_ENV !== 'development') {
            if(window.dataLayer) {
                const toPush = {
                    event: event,
                    eventValue: value
                };
                if(category) toPush['eventCategory'] = category;
                if(action) toPush['eventAction'] = action;
                if(label) toPush['eventLabel'] = label;

                //params
                for(const k in params) {
                    toPush[k] = params[k];
                }
                //console.log(window.dataLayer, toPush);
                window.dataLayer.push(toPush);
            }
        }
    }
}

export const trimEndSlash = (url) => {
    if(url[url.length - 1] == '/') {
        return url.slice(0, -1);
    } else {
        return url;
    }
}

export const esCape = (text) => {
    const tagsToReplace = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;'
    };
    return text.replace(/[&<>]/g, function(tag) {
        return tagsToReplace[tag] || tag;
    });
}

export const copyToClipboard = (str, country) => {

    const isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);

    if (isSafari)
    {
        if(typeof country != "undefined")
        {
            switch (country) {
                case 'th':
                    window.prompt("คัดลอกลิงก์ด้วยตนเอง:", str);
                    break;
                case 'id':
                    window.prompt("Salin Tautan Secara Manual:", str);
                    break;
                case 'my':
                    window.prompt("Salin pautan secara manual:", str);
                    break;
                case 'vn':
                    window.prompt("Sao chép liên kết theo cách thủ công:", str);
                    break;
                default:
                    window.prompt("Manually Copy Link:", str);
            }
        }
        else
        {
            window.prompt("Manually Copy Link:", str);
        }
    }
    else
    {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');

        const myAlert = document.createElement('div');
        myAlert.setAttribute("id", "copy-link-prompt")
        myAlert.style.position = 'fixed';
        myAlert.style.bottom = '55px';
        myAlert.style['z-index'] = '5';
        myAlert.style.left = '0';
        myAlert.style.right = '0';
        myAlert.style.display = 'inline-block';
        myAlert.style.margin = '0 auto';
        myAlert.style.width = '160px';
        myAlert.style['text-align'] = 'center';
        myAlert.style.padding = '10px 15px';
        myAlert.style.background = '#3CD295';
        myAlert.style.color = '#fff';
        myAlert.style['border-radius'] = '5px';
        myAlert.style['font-size'] = '14px';
        myAlert.style['z-index'] = '6';
        myAlert.style['font-weight'] = '500';
        myAlert.style['border-radius'] = '8px';

        let t = document.createTextNode("Link Copied");
        if(typeof country != "undefined")
        {
            switch (country) {
                case 'th':
                    t = document.createTextNode("คัดลอกลิงก์แล้ว");
                    break;
                case 'id':
                    t = document.createTextNode("Tautan Disalin");
                    break;
                case 'my':
                    t = document.createTextNode("Pautan Disalin");
                    break;
                case 'vn':
                    t = document.createTextNode("Đã sao chép liên kết");
                    break;
                default:
                    t = document.createTextNode("Link Copied");
            }
        }

        myAlert.appendChild(t);
        document.body.appendChild(myAlert);

        setTimeout(function(){
            document.body.removeChild(myAlert);
        }, 1000);

        document.body.removeChild(el);
    }
}

export const getScrollPostion = () => {
    return window.scrollY || window.pageYOffset || (document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop ? document.documentElement.scrollTop : 0));
}

export const makeRoute = ( url, appReducer ) => {
    let slug = url;
    if(appReducer.locale && url.indexOf('/q/') === -1) {
        const path = url.split('?');
        let vars = [];
        if(path[1]) {
            vars = path[1].split('&').filter(function (el) {
                if(el) {
                    return el
                }
                return false
            });
        }
        const index = vars.indexOf(`lng=${appReducer.locale}`);
        if(index !== -1) {
            vars[index] = `lng=${appReducer.locale}`;
        }
        else {
            vars.push(`lng=${appReducer.locale}`)
        }

        if(vars.length !== 0) {
            slug = path[0] + '?' + vars.join('&');
        }
        slug = slug.replace('?&', '?')
        slug = slug.replace('??', '?')
    }
    
    return slug
}

export const findIndexById = (id, list) => {
    let returnIndex = -1;
    for(const i in list) {
        if(list[i].id == id){
            returnIndex = i;
            break
        }
    }
    return parseInt(returnIndex);
}

export const findTopicIndexById = (id, list) => {
    let returnIndex = -1;
    for(const i in list) {
        if(list[i].topic.id == id){
            returnIndex = i;
            break
        }
    }
    return parseInt(returnIndex);
}

export const findBoothIndexById = (id, list) => {
    let returnIndex = -1;
    for(const i in list) {
        if(list[i].booth.id == id){
            returnIndex = i;
            break
        }
    }
    return parseInt(returnIndex);
}

export const setAdsDefinedSlot = (dfpKeys, device = "", callFrom = "preDefine") => {
    let isSet = true;
    if(device === "mobile" && !mobileCheck()) {
        isSet = false;
    }
    if(device === "desktop" && mobileCheck()) {
        isSet = false;
    }
    
    if(isSet && dfpKeys) {
        //Trigger ad define slot if adScriptStart fn is already called.
        if(typeof window.triggerDefinedSlot !== 'undefined' && typeof window.googletag !== 'undefined' && window.adScriptStartTriggered) {
            window.triggerDefinedSlot(dfpKeys);
            
            if(callFrom === "postDefine" && window.dfpPostDefineKey) {
                window.dfpPostDefineKey.push(dfpKeys)
            }
        }
        else if(window.dfpPreDefineKey){
            window.dfpPreDefineKey.push(dfpKeys)
        }
    }
}

export const generateDomainNewsUrl = ({country, slug}) => {
    switch (country) {
        case 'in':
            return `https://theindusparent.com/${slug || ''}`
        case 'vn':
            return `${siteNewsUrl[process.env.REACT_APP_ENV]}${slug || ''}`
    
        default:
            return `https://${['th', 'id', 'my', 'vn', 'ph', 'sg'].indexOf(country) !== -1 ? country : defaultCountry}.theasianparent.com/${slug || ''}`
    }
}

export const generateDomainCommunityUrl = ({country, slug}) => {
    const lng = countries.indexOf(country) !== -1 ? country : defaultCountry
    return `${siteCommunityUrl[process.env.REACT_APP_ENV]}${slug || ''}?lng=${lng}`
}

export const getUrlImage = ({imgPath, defaultImgPath = ''}) => {
    if (!imgPath) return ''
    let path = ''
    if (isBeYeuTemplate) {
        path = imgPath
    } else {
        if (defaultImgPath) {
            path = defaultImgPath
        } else {
            path = imgPath
        }
    }
    return CONFIG['region']['s3Prefix'] + path
}
export const generateParamsLogin = ({tokenUser= ''}) => {
    if(tokenUser){
        const buffToken = Buffer(tokenUser.toString(), 'base64')
        const key = Buffer(process.env.REACT_APP_SITE_BEYEU_ENCRYPT_KEY, 'utf8');

        const arrayUserInfo = buffToken.toString('ascii').replace(/socialId=|email=/gi,'').split('&');
     
        const id = arrayUserInfo[0];
        const email = arrayUserInfo[1];

        const plaintext = Buffer(id, 'utf8');
        const cipher = crypto.createCipheriv("aes-128-ecb", key, Buffer.alloc(0));
        cipher.setAutoPadding(true);
        const ciphertext = Buffer.concat([
            cipher.update(plaintext, 'utf8'),
            cipher.final()
        ]);
        const password = ciphertext.toString('base64');
        return { email, password }
    }
}

export const generateParamsUpdateProfile = ({ tapId }) => {
    const profile = JSON.stringify({tap_id:tapId,is_login:true})
    
    const cipher = crypto.createCipheriv("aes-128-ecb", process.env.REACT_APP_SITE_BEYEU_ENCRYPT_KEY, Buffer.alloc(0));
    const ciphertext = Buffer.concat([
        cipher.update(profile, 'utf8'),
        cipher.final()
    ]);
    
    const token = Buffer.from(ciphertext.toString('base64')).toString('base64')

    return `${process.env.REACT_APP_SITE_BEYEU_EDIT_PROFILE}/?tap_access_token=${token}`
}

export const redirectBeYeuLogin = () => window.location.href = `${process.env.REACT_APP_SITE_BEYEU_LOGIN}?prevPath=${window.location.href}`